import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import { Fragment, useEffect, useState } from "react";
import { getAuth } from "./redux/features/authSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import {
  Dashboard,
  DashboardLanding,
  Login,
  MerchantTransaction,
  NotFound,
  PrivateRoute
} from "./pages/pageListAsync";

function App() {
  const [data, setData] = useState({ sideBarLinks: [] });
  useEffect(() => {
    import("./utils/constants").then(({ sideBarLinks }) => {
      setData({ sideBarLinks });
    });
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleLogOut = async () => {
      try {
        Cookies.remove("accessToken");
        Cookies.remove("testnetaccessToken");
        localStorage.removeItem("accessToken");
        Cookies.remove(`${process.env.REACT_APP_NETWORK}accessToken`);
        navigate("/");
        toast.success(
          "Your session has expired. Please log in again to continue"
        );
      } catch (err) {
        toast.error(err.message);
      }
    };

    const setAuth = async () => {
      try {
        const result = dispatch(getAuth());
        if (result?.payload?.response?.data?.message === "Unauthorized") {
          await handleLogOut();
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (Cookies.get(`${process.env.REACT_APP_NETWORK}accessToken`) === "true") {
      setAuth();
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const cookeiData = Cookies.get(
      `${process.env.REACT_APP_NETWORK}accessToken`
    );
    if (!cookeiData) {
      navigate("/");
    }
  }, [navigate]);
  return (
    <>
      <ToastContainer autoClose={2000} />
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index path="dashboard" element={<DashboardLanding />}></Route>
          <Route
            path="merchant-transaction/:merchantId"
            element={<MerchantTransaction />}
          ></Route>

          {data?.sideBarLinks.map((item, index) => {
            if (item.component === null && item.child) {
              return item.child.map((childItem, childIndex) => (
                <Route
                  key={`${index}-${childIndex}`}
                  path={childItem.path}
                  element={<Fragment>{childItem.component}</Fragment>}
                />
              ));
            } else if (item.title !== "Dashboard") {
              // Render routes for other items except "Dashboard"
              return (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                />
              );
            }
            return null;
          })}

          <Route path="*" element={<NotFound />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
